import * as React from 'react';

interface MailLinkProps {
	mail: string;
	children: React.ReactNode;
}

export const MailLink: React.FC<MailLinkProps> = (props: MailLinkProps) => (
	<a href={`mailto:${props.mail}`}>
		{props.children}
	</a>
);
